import React, { useState, useEffect } from 'react';

// Global reference to the addToast function
let addToastFn = null;

export const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);
    
    useEffect(() => {
        addToastFn = (message, type = 'success') => {
            const id = Date.now() + Math.random();
            setToasts(prev => [...prev, { id, message, type }]);
            
            // Auto-remove after 3 seconds
            setTimeout(() => {
                setToasts(prev => prev.filter(t => t.id !== id));
            }, 3000);
        };

        return () => {
            addToastFn = null;
        };
    }, []);

    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    };

    return (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-[999999] flex flex-col gap-3 pointer-events-auto">
            {toasts.map(t => (
                <div 
                    key={t.id} 
                    className="relative overflow-hidden bg-white px-4 py-3 min-w-[300px] max-w-[400px] flex items-start gap-3 rounded-md shadow-[0_3px_10px_rgb(0,0,0,0.2)] animate-fade-in-up"
                >
                    {/* Icon */}
                    <div className="shrink-0 mt-0.5">
                        {t.type === 'success' && (
                            <svg className="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                        )}
                        {t.type === 'error' && (
                            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                        )}
                        {t.type === 'warning' && (
                            <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                        )}
                        {t.type === 'info' && (
                            <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                        )}
                    </div>
                    
                    {/* Message */}
                    <div className="flex-1 text-sm text-gray-700 font-medium break-words leading-relaxed pt-0.5">
                        {t.message}
                    </div>

                    {/* Close Button */}
                    <button onClick={() => removeToast(t.id)} className="shrink-0 text-gray-400 hover:text-gray-600 transition-colors">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>

                    {/* Progress Bar */}
                    <div 
                        className={`absolute bottom-0 left-0 h-[3px] animate-[shrink_3s_linear_forwards] ${
                            t.type === 'error' ? 'bg-red-500' : 
                            t.type === 'warning' ? 'bg-amber-500' : 
                            t.type === 'info' ? 'bg-blue-500' : 
                            'bg-emerald-500'
                        }`} 
                        style={{ width: '100%' }}
                    />
                </div>
            ))}
        </div>
    );
};

export const toast = {
    success: (msg) => {
        if (addToastFn) addToastFn(msg, 'success');
        else console.log("SUCCESS:", msg);
    },
    error: (msg) => {
        if (addToastFn) addToastFn(msg, 'error');
        else console.log("ERROR:", msg);
    },
    info: (msg) => {
        if (addToastFn) addToastFn(msg, 'info');
        else console.log("INFO:", msg);
    },
    warning: (msg) => {
        if (addToastFn) addToastFn(msg, 'warning');
        else console.log("WARNING:", msg);
    }
};
